import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { ProductsServices } from "../../../services";
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProvidersServices } from "../../../../providers/services";
import { StaticsServices } from "../../../../services/statics";
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../../services/analyticsServices';
import { AngularFirestore } from 'angularfire2/firestore';
import firebase from 'firebase';

/**
 * Generated class for the ProductCreateWfoodcostStockPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-create-wfoodcost-add-stock',
  templateUrl: 'product-create-wfoodcost-add-stock.html',
})
export class ProductCreateWfoodcostAddStockPage {

  public firestore;
  public form: FormGroup;
  product_name: any;
  product_uid: string;
  update_state: boolean = false;
  product_measurement: String;
  product: any;
  stock_actual: any;
  stock_añadir: any;
  stock_suficiente: any;
  stock_ingredients: any;
  ingredients = [];
  show_alert: boolean = true;
  old_stock: number = 0;
  units = 0;
  stock_final: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public productsServices: ProductsServices,
    public fb: FormBuilder,
    public globals: Globals,
    public providersServices: ProvidersServices,
    public staticsServices: StaticsServices,
    public translate: TranslateService,
    private analyticsService: AnalyticsServices,
    public afs: AngularFirestore) {
    this.firestore = firebase.firestore();

    //Params
    this.update_state = this.navParams.get('update_state');
    this.product_name = this.navParams.get('product_name');
    this.product_uid = this.navParams.get('product_uid');
    this.product_measurement = this.navParams.get('product_measurement');
    this.product = this.navParams.get('product');
    this.stock_final = this.navParams.get('stock');


    this.stock_ingredients = this.product.foodcost;

    for (let product_fc_key in this.product.foodcost) {
      //añadir la variable que marca si el stock es suficiente
      this.product.foodcost[product_fc_key].stock_suficiente = true;

      if (this.product.foodcost[product_fc_key].measurement_static == 'gr') {
        this.product.foodcost[product_fc_key].measurement = 'kg'
      } else if (this.product.foodcost[product_fc_key].measurement_static == 'ml') {
        this.product.foodcost[product_fc_key].measurement = 'l'

      } else {

        this.product.foodcost[product_fc_key].measurement = this.product.foodcost[product_fc_key].measurement_static

      }
    }
    //Recuperamos la informacion de los ingredientes del producto
    for (let ingredient of this.product.foodcost) {
      this.firestore.collection('ingredients').doc(ingredient.uid).get().then(doc => {
        var _doc = doc.data();
        _doc.UID = doc.id;
        this.ingredients.push(_doc);

        ingredient.stock_ = _doc.stock;
        ingredient.stock_post = _doc.stock;
      });
    }

    //Si hacemos update adamptamos la informacion
    if (this.update_state) {
      this.old_stock = this.navParams.get('stock');
      this.productsServices.product_tags = this.navParams.get('tags');

      this.form = fb.group({
        stock: [this.navParams.get('stock')],
        stock_alert: [this.units],
        stock_max: [this.stock_final],
        sub_recipe: [false],
        reason: '',
        reason_desc: '',
      });

    } else {
      this.productsServices.product_tags = Array();

      this.form = fb.group({
        stock: [0],
        stock_alert: [0],
        stock_max: [0],
        sub_recipe: [false],
        reason: 'new_product',
        reason_desc: '',
      });
    }
  }

  sendData() {
    var extra = {
      "min_stock": this.form.value.stock_alert,
      "max_stock": this.form.value.stock_max,
    };
    this.globals.dataSet('product_name', this.product_name, '', JSON.stringify(extra));
  }

  sendDataChangeStock() {
    var extra = {
      "stock": this.form.value.stock,
      "min_stock": this.form.value.stock_alert,
      "max_stock": this.form.value.stock_max,
      "reason": this.form.value.reason,
      "reason_desc": this.form.value.reason_desc,
    };
    this.globals.dataSet('product_stock', this.product_name, '', JSON.stringify(extra));
  }

  async sendStockAnalytics(stock) {
    this.analyticsService.sendStock(stock);
  }

  async onChange(units) {
    this.units = parseFloat(units);

    //sumar al stock actual valor maximo
    this.form.value.stock_max = parseFloat(this.form.value.stock) + parseFloat(units);

    this.stock_final = this.form.value.stock_max;

    //actualizar el formulario
    this.form.patchValue({
      stock_max: this.stock_final
    });

    for (let product_fc_key in this.product.foodcost) {
      //restamos el stock de los ingredientes del plato
      await this.deductStockIngredient(this.ingredients, this.product.foodcost[product_fc_key], this.product.foodcost_parts, this.globals.restaurant, false);
    }
  }

  async addStockWfoodcost() {
    this.globals.GAtrackView('Products', 'Products - Stock - Update', this.globals.restaurant.email, 'Create/Update', 'Update stock', 'Products', this.product_name);

    //funcion que añade stock en el producto con escandallo
    for (let product_fc_key in this.product.foodcost) {
      await this.deductStockIngredient(this.ingredients, this.product.foodcost[product_fc_key], this.product.foodcost_parts, this.globals.restaurant, true);
    }

    var _stock = 0;
    var units = this.units;

    //get producto firestore
    await this.firestore.collection('products').doc(this.product_uid).get().then((doc) => {
      if (doc.exists) {
        _stock = parseFloat(doc.data().stock);
      }
    });

    //añadir stock
    var final_stock = _stock + units;

    //actualizar el stock del products
    this.firestore.collection('products').doc(this.product_uid).update({
      'stock': final_stock,
      'updated_at': new Date(),
      'updated_user': this.globals.user_name
    });
    //lanzar bigquery del elemento que añadimos stock
    var stock = {
      "elements": [{
        "uid_element": this.product_uid,
        "name": this.product_name,
        "price": Math.abs(this.product.price_static * (final_stock - this.old_stock)), //Siempre numero positivo
        "quantity": (final_stock - this.old_stock),
        "measurement": this.product.measurement,
        "modifier": "",
      }],
      "uid": this.globals.restaurant_uid,
      "date": new Date(),
      "type": "stock",
      "comment": this.form.value.reason_desc,
      "type_type": "MANUAL",
      "delivery_uid": null
    };
    this.sendStockAnalytics(stock);
    this.navCtrl.pop();
  }

  async deductStockIngredient(ingredients, foodcost_element, foodcost_parts, restaurant, restar_stock) {
    var index_ingr = ingredients.findIndex(x => x.UID == foodcost_element.uid);

    //comprovar que  ingr existe
    if (index_ingr >= 0) { //caso producto existe
      var _ingr;
      //consulta firebase para recuperar el ingrediente
      await this.firestore.collection('ingredients').doc(foodcost_element.uid).get()
        .then(doc => {
          if (doc.exists) {
            _ingr = doc.data();
            _ingr.UID = doc.id;
          }
        })
        .catch(err => { });

      var _stock = await this.calculateMeasurements(_ingr.measurement, _ingr.stock, (this.divideQuantityFoodcostparts(foodcost_parts, foodcost_element.quantity_gross) * this.units));
      //find index this.product.foodcost
      var index = this.product.foodcost.findIndex(x => x.uid == _ingr.UID);

      //comprobar que queda stock suficiente
      if (_stock >= 0) {
        this.product.foodcost[index].stock_suficiente = true;
        this.product.foodcost[index].stock_post = _stock;

        //actualizar el stock
        if (restar_stock) {
          await this.firestore.collection('ingredients').doc(foodcost_element.uid).update({
            'stock': _stock,
          }).then(() => {
            ingredients[index_ingr].stock = _stock;
          });
        }
      } else {
        _stock = 0;

        //this.product.foodcost.stock_suficiente = false
        this.product.foodcost[index].stock_suficiente = false;
        this.product.foodcost[index].stock_post = _stock;

        //crear una notificacion de stock insuficiente
        if (_ingr.stock != 0) {
          if (restar_stock) {
            await this.firestore.collection('ingredients').doc(foodcost_element.uid).update({
              'stock': 0,
            }).then(() => {
              ingredients[index_ingr].stock = 0;
            });
          }
        }
        //notifMinStock(_stock, ingredients[index_ingr].stock_alert, getNameIngredientLang(ingredients[index_ingr], restaurant.lang), restaurant);
      }
      //lanzar bigquery de los elementos que quitamos stock
      if (restar_stock) {
        var stock = {
          "elements": [{
            "uid_element": ingredients[index_ingr].UID,
            "name": ingredients[index_ingr].name,
            "price": Math.abs(ingredients[index_ingr].price_static * (_stock - foodcost_element.stock_)), //Siempre numero positivo
            "quantity": (_stock - foodcost_element.stock_),
            "measurement": ingredients[index_ingr].measurement,
            "modifier": this.product_name,
          }],
          "uid": this.globals.restaurant_uid,
          "date": new Date(),
          "type": "stock",
          "comment": this.form.value.reason_desc,
          "type_type": "MANUAL",
          "delivery_uid": null
        };
        this.sendStockAnalytics(stock);
      }
    }
  }

  calculateMeasurements(measurement, stock, minus_stock) {
    //multiplicar minus_stock(lo que se resta) por las units(unidades de ese elemento)
    var return_stock = 0;
    if (measurement === 'kg' || measurement === 'l') {
      //kg l
      var stock_grams_ml = stock * 1000;
      var total = stock_grams_ml - parseFloat(minus_stock);

      return_stock = total / 1000;
    } else if (measurement === 'ud.') {
      return_stock = stock - minus_stock;
    } else {
      return_stock = parseFloat(stock) - parseFloat(minus_stock);
    }

    return parseFloat(return_stock.toFixed(3));
  }

  checkIfStockNegative(stock) {
    if (stock >= 0) {
      return parseFloat(stock);
    } else {
      return 0;
    }
  }

  divideQuantityFoodcostparts(parts, quantity) {
    return parseFloat(quantity) / parseFloat(parts);
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-add-stock/product-create-wfoodcost-add-stock.ts